// Port of whatsapp-console-frontend `src/pages/AdTemplates/generationStatus.js`.
// `progress.stage` arrives as English copy from the ad-templates service; an
// unknown stage falls back to GETTING_READY instead of leaking server text.

export const GETTING_READY = 'Getting your ads ready…';
export const READY = 'Your ads are ready to review';

const PERSONALIZING = 'Personalizing your ads…';

const STAGE_TEXT: Record<string, string> = {
  Queued: GETTING_READY,
  'Reading your prompt': PERSONALIZING,
  'Looking up your business': PERSONALIZING,
  'Building audience': PERSONALIZING,
  'Choosing the ad types': 'Planning your ad formats…',
  'Designing the creative': 'Designing your creatives…',
  'Finishing up': 'Putting the finishing touches…',
  'Putting it together': 'Putting the finishing touches…',
  complete: READY,
};

export const generationLabel = (progress?: { stage?: string } | null): string =>
  STAGE_TEXT[String((progress || {}).stage || '').trim()] || GETTING_READY;
